import { Prop, Component, Vue } from 'vue-property-decorator';
import LooseObject from '@/models/Objects/LooseObject';

@Component
export default class FilesDownload extends Vue {
    @Prop() public props!: LooseObject;
}
